<template name="production-planning-form">
  <v-dialog v-model="dialog" width="800">
    <template #activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" v-on="on">
        Regelkonfiguration
      </v-btn>
    </template>
    <RuleConfirmationDialog
      v-model="isRuleConfirmationDialogOpen"
      :get-content="getContent"
      :update-rules-name-list="updateRulesNameList"
      :rule-object="ruleObject"
      :rule-name-prop="rule"
      :rule-requestbody="ruleRequestbody"
      :title="getContent('rule_saving_dialog_title')"
      :button="getContent('rule_saving_button')"
      @saved="
        $emit('saved', { rule: rule })
        reset()
        dialog = false
      "
    >
    </RuleConfirmationDialog>
    <ConfirmationDialog
      v-model="isDeletionConfirmationDialogOpen"
      :title="getContent('rule_deletion_dialog_title')"
      :dialog-content="getContent('rule_deletion_dialog_content')"
      :button="getContent('rule_deletion_dialog_button')"
      @confirmed="deleteRule"
    >
    </ConfirmationDialog>
    <form class="production-planning-form">
      <v-card>
        <v-card-title class="justify-center">
          <h1 class="headline text-center primary--text">
            {{ getContent('rule_configuration_title') }}
          </h1>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid>
            <v-row align="center">
              <v-col class="py-0 d-flex" cols="6">
                <v-select
                  id="rule"
                  v-model="rule"
                  :items="rules"
                  :label="getContent('rule_selection')"
                  outlined
                  dense
                  required
                  @change="changeRule"
                ></v-select>
              </v-col>
              <v-col class="py-0 d-flex" cols="6">
                <v-select
                  id="colorMode"
                  v-model="colorMode"
                  :items="colorModes"
                  :label="getContent('color')"
                  :error-messages="colorModeValidationError"
                  outlined
                  dense
                  required
                ></v-select>
              </v-col>
              <v-col class="py-0 d-flex" cols="6">
                <v-select
                  id="regionFrom"
                  v-model="regionFrom"
                  :items="regionFromArray"
                  :label="getContent('region_from')"
                  :error-messages="regionFromValidationError"
                  outlined
                  dense
                  required
                ></v-select>
              </v-col>
              <v-col class="py-0 d-flex" cols="6">
                <v-select
                  id="regionTo"
                  v-model="regionTo"
                  :items="regionToArray"
                  :label="getContent('region_to')"
                  :error-messages="regionToValidationError"
                  outlined
                  dense
                  required
                ></v-select>
              </v-col>
              <v-col class="py-0 d-flex" cols="6">
                <v-select
                  id="regionExclude"
                  v-model="regionExclude"
                  :items="regionExcludeArray"
                  :label="getContent('region_exclude')"
                  outlined
                  dense
                  multiple
                  required
                ></v-select>
              </v-col>
              <v-col class="py-0 d-flex" cols="6">
                <v-select
                  id="letterType"
                  v-model="letterType"
                  :items="letterTypes"
                  :label="getContent('letter_class')"
                  :error-messages="letterTypeValidationError"
                  outlined
                  dense
                  required
                ></v-select>
              </v-col>
              <v-col class="py-0 d-flex" cols="6">
                <v-select
                  id="foldType"
                  v-model="foldType"
                  :items="foldTypes"
                  :label="getContent('fold_type')"
                  :error-messages="foldTypeValidationError"
                  outlined
                  dense
                  required
                ></v-select>
              </v-col>
              <v-col class="py-0 d-flex" cols="6">
                <v-select
                  id="paperType"
                  v-model="paperType"
                  :items="paperTypes"
                  :label="getContent('paper_type')"
                  :error-messages="paperTypeValidationError"
                  outlined
                  dense
                  required
                ></v-select>
              </v-col>
              <v-col class="py-0 d-flex" cols="6">
                <v-select
                  id="coverType"
                  v-model="coverType"
                  :items="coverTypes"
                  :label="getContent('cover_type')"
                  :error-messages="coverTypeValidationError"
                  outlined
                  dense
                  required
                ></v-select>
              </v-col>
              <v-col class="py-0 d-flex" cols="6">
                <v-select
                  id="printMode"
                  v-model="printMode"
                  :items="printModes"
                  :label="getContent('simplex_duplex')"
                  :error-messages="printModeValidationError"
                  outlined
                  dense
                  required
                ></v-select>
              </v-col>
              <v-col class="py-0 d-flex" cols="6">
                <v-select
                  id="frankingType"
                  v-model="frankingType"
                  :items="frankingTypes"
                  :label="getContent('dv')"
                  :error-messages="frankingTypeValidationError"
                  outlined
                  dense
                  required
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-checkbox
                  v-model="hasOnlyFullBatches"
                  :label="getContent('full_batches')"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  v-model="isRialtoCapable"
                  :label="getContent('rialto_capabale')"
                  color="primary"
                  hide-details
                  disabled
                ></v-checkbox>
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  v-model="isWithSupplement"
                  :label="getContent('supplement')"
                  color="primary"
                  hide-details
                  disabled
                ></v-checkbox>
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  v-model="isWithInternational"
                  :label="getContent('international_letters')"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            id="ResetRule"
            class="text-center px-8"
            width="200px"
            color="primary"
            dark
            depressed
            @click.stop="reset"
            >{{ getContent('reset_rule') }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            id="deleteRule"
            :disabled="rule === ''"
            class="text-center px-8"
            width="200px"
            color="error"
            dark
            depressed
            @click.stop="openRuleDeletionDialog"
            >{{ getContent('delete_rule') }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            id="saveRule"
            class="text-center px-8"
            width="200px"
            color="success"
            dark
            depressed
            @click.stop="openSaveRuleDialog"
            >{{ getContent('save_rule') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </form>
  </v-dialog>
</template>
<script>
import { cmsService } from '@/services'
import { rulesService } from '@/services/rules'
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import RuleConfirmationDialog from '@/components/dialogs/RuleConfirmationDialog'
import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog'
import formContent from '@/data/json/forms/ProductionInformation'
import { LetterType } from '@/enums/LetterType'
import { FrankingType } from '@/enums/FrankingType'
import { FoldType } from '@/enums/FoldType'
import { PaperType } from '@/enums/PaperType'
import { CoverType } from '@/enums/CoverType'
import { PrintMode } from '@/enums/PrintMode'
import { ColorMode } from '@/enums/ColorMode'
import { EnumBaseMixin } from '@/enums/EnumBaseMixin'
export default {
  components: { RuleConfirmationDialog, ConfirmationDialog },
  mixins: [validationMixin, EnumBaseMixin],
  validations: {
    letterType: { required },
    regionFrom: { required },
    regionTo: { required },
    hasOnlyFullBatches: { required },
    foldType: { required },
    paperType: { required },
    coverType: { required },
    isWithSupplement: { required },
    isRialtoCapable: { required },
    printMode: { required },
    colorMode: { required },
    frankingType: { required }
  },
  props: {
    preselectedRule: { type: String, default: '' }
  },
  data: vm => ({
    dialog: false,
    content: formContent.data,
    isRuleConfirmationDialogOpen: false,
    isDeletionConfirmationDialogOpen: false,
    ruleObject: {},
    ruleRequestbody: {},
    letterTypes: [
      {
        value: LetterType.Standard,
        text: vm.getEnumsContent('LetterType', LetterType.Standard)
      },
      {
        value: LetterType.Compact,
        text: vm.getEnumsContent('LetterType', LetterType.Compact)
      },
      {
        value: LetterType.Large,
        text: vm.getEnumsContent('LetterType', LetterType.Large)
      },
      {
        value: LetterType.PZU,
        text: vm.getEnumsContent('LetterType', LetterType.PZU)
      },
      {
        value: LetterType.Maxi,
        text: vm.getEnumsContent('LetterType', LetterType.Maxi)
      },
      {
        value: LetterType.MaxiPlus,
        text: vm.getEnumsContent('LetterType', LetterType.MaxiPlus)
      },
      {
        value: LetterType.Package,
        text: vm.getEnumsContent('LetterType', LetterType.Package)
      }
    ],
    frankingTypes: [
      {
        value: FrankingType.DVFr,
        text: vm.getEnumsContent('FrankingType', FrankingType.DVFr)
      },
      {
        value: FrankingType.Envelope,
        text: vm.getEnumsContent('FrankingType', FrankingType.Envelope)
      }
    ],
    foldTypes: [
      {
        value: FoldType.Size105,
        text: vm.getEnumsContent('FoldType', FoldType.Size105)
      },
      {
        value: FoldType.Size87,
        text: vm.getEnumsContent('FoldType', FoldType.Size87)
      }
    ],
    paperTypes: [
      {
        value: PaperType.Blank,
        text: vm.getEnumsContent('PaperType', PaperType.Blank)
      },
      {
        value: PaperType.PaymentSlip_Bottom,
        text: vm.getEnumsContent('PaperType', PaperType.PaymentSlip_Bottom)
      },
      {
        value: PaperType.PZU,
        text: vm.getEnumsContent('PaperType', PaperType.PZU)
      }
    ],
    coverTypes: [
      {
        value: CoverType.Blank,
        text: vm.getEnumsContent('CoverType', CoverType.Blank)
      },
      {
        value: CoverType.Customer,
        text: vm.getEnumsContent('CoverType', CoverType.Customer)
      }
    ],
    printModes: [
      {
        value: PrintMode.Simplex,
        text: vm.getEnumsContent('PrintMode', PrintMode.Simplex)
      },
      {
        value: PrintMode.Duplex,
        text: vm.getEnumsContent('PrintMode', PrintMode.Duplex)
      }
    ],
    colorModes: [
      {
        value: ColorMode.Color,
        text: vm.getEnumsContent('ColorMode', ColorMode.Color)
      },
      {
        value: ColorMode.Sw,
        text: vm.getEnumsContent('ColorMode', ColorMode.Sw)
      },
      {
        value: ColorMode.All,
        text: vm.getEnumsContent('ColorMode', ColorMode.All)
      }
    ],
    letterType: null,
    frankingType: null,
    foldType: null,
    paperType: null,
    coverType: null,
    printMode: null,
    colorMode: null,
    rules: [],
    rule: '',
    regionFromArray: [],
    regionFrom: '00',
    regionToArray: [],
    regionTo: '99',
    regionExcludeArray: [],
    regionExclude: [],
    hasOnlyFullBatches: false,
    isRialtoCapable: true,
    isWithSupplement: false,
    isWithInternational: true,
    ruleSelected: false,
    submitError: false,
    showNotification: false,
    registerStatus: {
      type: 'error',
      msg: ''
    }
  }),
  computed: {
    letterTypeValidationError() {
      const errors = []
      if (!this.$v.letterType.$dirty) return errors
      !this.$v.letterType.required &&
        errors.push(this.getContent('field_neccessary'))
      return errors
    },
    regionFromValidationError() {
      const errors = []
      if (!this.$v.regionFrom.$dirty) return errors
      !this.$v.regionFrom.required &&
        errors.push(this.getContent('field_neccessary'))
      return errors
    },
    regionToValidationError() {
      const regionFromInteger = Number.parseInt(this.regionFrom, 10)
      const regionToInteger = Number.parseInt(this.regionTo, 10)
      const regionsCorrect = regionFromInteger <= regionToInteger
      const errors = []
      if (!this.$v.regionTo.$dirty) return errors
      !regionsCorrect && errors.push(this.getContent('region_validation_error'))
      return errors
    },
    hasOnlyFullBatchesValidationError() {
      const errors = []
      if (!this.$v.hasOnlyFullBatches.$dirty) return errors
      !this.$v.hasOnlyFullBatches.required &&
        errors.push(this.getContent('field_neccessary'))
      return errors
    },
    foldTypeValidationError() {
      const errors = []
      if (!this.$v.foldType.$dirty) return errors
      !this.$v.foldType.required &&
        errors.push(this.getContent('field_neccessary'))
      return errors
    },
    paperTypeValidationError() {
      const errors = []
      if (!this.$v.paperType.$dirty) return errors
      !this.$v.paperType.required &&
        errors.push(this.getContent('field_neccessary'))
      return errors
    },
    coverTypeValidationError() {
      const errors = []
      if (!this.$v.coverType.$dirty) return errors
      !this.$v.coverType.required &&
        errors.push(this.getContent('field_neccessary'))
      return errors
    },
    isWithSupplementValidationError() {
      const errors = []
      if (!this.$v.isWithSupplement.$dirty) return errors
      !this.$v.isWithSupplement.required &&
        errors.push(this.getContent('field_neccessary'))
      return errors
    },
    isRialtoCapableValidationError() {
      const errors = []
      if (!this.$v.isRialtoCapable.$dirty) return errors
      !this.$v.isRialtoCapable.required &&
        errors.push(this.getContent('field_neccessary'))
      return errors
    },
    printModeValidationError() {
      const errors = []
      if (!this.$v.printMode.$dirty) return errors
      !this.$v.printMode.required &&
        errors.push(this.getContent('field_neccessary'))
      return errors
    },
    colorModeValidationError() {
      const errors = []
      if (!this.$v.colorMode.$dirty) return errors
      !this.$v.colorMode.required &&
        errors.push(this.getContent('field_neccessary'))
      return errors
    },
    frankingTypeValidationError() {
      const errors = []
      if (!this.$v.frankingType.$dirty) return errors
      !this.$v.frankingType.required &&
        errors.push(this.getContent('field_neccessary'))
      return errors
    }
  },
  watch: {
    dialog: function (dialogState) {
      // is dialog open
      if (dialogState && this.preselectedRule) {
        // update rule
        this.rule = this.preselectedRule
        this.changeRule()
      }
    }
  },
  created() {
    const regions = this.generateRegions()
    this.updateRuleObject(this.ruleObject)
    this.regionFromArray = regions
    this.regionToArray = regions
    this.regionExcludeArray = regions
    this.updateRulesNameList()
  },
  methods: {
    ...mapActions(['fetchRules']),
    openSaveRuleDialog: function () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitError = true
      } else {
        this.updateRuleObject(this.ruleObject)
        this.ruleRequestbody = this.getRequestBody()
        this.isRuleConfirmationDialogOpen = true
      }
    },
    openRuleDeletionDialog: function () {
      this.isDeletionConfirmationDialogOpen = true
    },
    deleteRule() {
      const selectedRule = rulesService.getRuleByName(this.rule)
      rulesService.deleteRule(selectedRule).then(() => {
        this.isDeletionConfirmationDialogOpen = false
        this.reset()
        this.fetchRules().then(() => {
          this.updateRulesNameList()
          this.$emit('saved')
          this.dialog = false
        })
      })
    },
    reset() {
      this.$v.$reset()
      this.rule = ''
      this.regionFrom = '00'
      this.regionTo = '99'
      this.regionExclude = []
      this.hasOnlyFullBatches = false
      this.isRialtoCapable = true
      this.isWithSupplement = false
      this.isWithInternational = true
      this.letterType = null
      this.frankingType = null
      this.foldType = null
      this.paperType = null
      this.coverType = null
      this.printMode = null
      this.colorMode = null
      this.updateRuleObject(this.ruleObject)
    },
    getRequestBody: function () {
      let requestBody = {}
      requestBody.hasOnlyFullBatches = this.hasOnlyFullBatches
      requestBody.frankingType = this.frankingType
      requestBody.isRialtoCapable = this.isRialtoCapable
      requestBody.isWithSupplement = this.isWithSupplement
      requestBody.isWithInternational = this.isWithInternational
      requestBody.letterType = this.letterType
      requestBody.paperType = this.paperType
      requestBody.coverType = this.coverType
      requestBody.printMode = this.printMode
      requestBody.colorMode = this.colorMode
      requestBody.foldType = this.foldType
      requestBody.selectedRegions = this.generateSelectedRegions()
      return requestBody
    },
    updateRuleObject: function (newRuleObject) {
      newRuleObject.rule = this.rule
      newRuleObject.letterType = this.letterType
      newRuleObject.regionFrom = this.regionFrom
      newRuleObject.regionTo = this.regionTo
      newRuleObject.regionExclude = this.regionExclude
      newRuleObject.hasOnlyFullBatches = this.hasOnlyFullBatches
      newRuleObject.foldType = this.foldType
      newRuleObject.paperType = this.paperType
      newRuleObject.coverType = this.coverType
      newRuleObject.isWithSupplement = this.isWithSupplement
      newRuleObject.isWithInternational = this.isWithInternational
      newRuleObject.isRialtoCapable = this.isRialtoCapable
      newRuleObject.printMode = this.printMode
      newRuleObject.colorMode = this.colorMode
      newRuleObject.frankingType = this.frankingType
      this.ruleObject = newRuleObject
      this.fetchRules()
    },
    changeRule() {
      this.fetchRules()
      const selectedRule = rulesService.getRuleByName(this.rule)
      this.letterType = selectedRule.letterType
      this.rule = selectedRule.ruleName
      this.regionFrom = selectedRule.selectedRegions[0]
      this.regionTo = selectedRule.selectedRegions.slice(-1)[0]
      this.regionExclude = this.convertRegionExclude(
        selectedRule.selectedRegions
      )
      this.hasOnlyFullBatches = selectedRule.hasOnlyFullBatches
      this.foldType = selectedRule.foldType
      this.paperType = selectedRule.paperType
      this.coverType = selectedRule.coverType
      this.isWithSupplement = selectedRule.isWithSupplement
      this.isWithInternational = selectedRule.isWithInternational
      this.isRialtoCapable = selectedRule.isRialtoCapable
      this.printMode = selectedRule.printMode
      this.colorMode = selectedRule.colorMode
      this.frankingType = selectedRule.frankingType
      this.ruleObject.id = selectedRule.id
      this.updateRuleObject(this.ruleObject)
    },
    //#region "Regions"
    generateRegions() {
      const regionArray = []
      for (let i = 0; i <= 99; i++) {
        if (i < 10) {
          regionArray.push('0' + i.toString())
        } else {
          regionArray.push(i.toString())
        }
      }
      return regionArray
    },
    generateSelectedRegions: function () {
      let selectedRegions = this.generateRegions()
      selectedRegions = selectedRegions.filter(
        region => region >= this.regionFrom
      )
      selectedRegions = selectedRegions.filter(
        region => region <= this.regionTo
      )
      this.regionExclude.forEach(excludedRegion => {
        selectedRegions = selectedRegions.filter(
          region => region !== excludedRegion
        )
      })
      return selectedRegions
    },
    convertRegionExclude: function (selectedRegions) {
      let regions = this.generateRegions()
      regions = regions.filter(
        region =>
          region < selectedRegions[0] || region > selectedRegions.slice(-1)[0]
      )
      return regions
    },
    //#endregion "Regions"
    updateRulesNameList: function () {
      const updatedRules = rulesService.getRulesNameList()
      this.rules = updatedRules.sort(function (a, b) {
        return ('' + a).localeCompare(b)
      })
    },
    getContent: function (name) {
      const returnValue = cmsService.filterCMSContent(formContent.data, name)
      return returnValue
    }
  }
}
</script>
